module.exports = __webpack_public_path__ + "img/qy_6.9fc894c1.png";